import _kebabCase from "lodash/kebabCase";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
import highlight from 'highlight.js';
import 'highlight.js/styles/androidstudio.css';
import { previewCode } from '../../api/code-gen';
import { useCommonDialog } from '@/component-create/utils/hooks';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Preview',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var dialogRef = useCommonDialog('dialogRef');
    var tab = ref({
      active: 'entity',
      loading: false
    });
    var preview = ref({
      businessName: '',
      entity: '',
      mapper: '',
      mapperXml: '',
      service: '',
      serviceImpl: '',
      controller: '',
      importHandler: '',
      api: '',
      managerView: '',
      createView: '',
      updateView: '',
      ieo: '',
      viewConfig: ''
    });
    var entityCode = computed(function () {
      return highlight.highlight('java', preview.value.entity).value;
    });
    var mapperCode = computed(function () {
      return highlight.highlight('java', preview.value.mapper).value;
    });
    var mapperXmlCode = computed(function () {
      return highlight.highlight('xml', preview.value.mapperXml).value;
    });
    var serviceCode = computed(function () {
      return highlight.highlight('java', preview.value.service).value;
    });
    var serviceImplCode = computed(function () {
      return highlight.highlight('java', preview.value.serviceImpl).value;
    });
    var controllerCode = computed(function () {
      return highlight.highlight('java', preview.value.controller).value;
    });
    var ieoCode = computed(function () {
      return highlight.highlight('java', preview.value.ieo).value;
    });
    var importHandlerCode = computed(function () {
      return highlight.highlight('java', preview.value.importHandler).value;
    });
    var api = computed(function () {
      return highlight.highlight('java', preview.value.api).value;
    });
    var managerView = computed(function () {
      return highlight.highlight('java', preview.value.managerView).value;
    });
    var createView = computed(function () {
      return highlight.highlight('java', preview.value.createView).value;
    });
    var updateView = computed(function () {
      return highlight.highlight('java', preview.value.updateView).value;
    });
    var viewConfig = computed(function () {
      return highlight.highlight('java', preview.value.viewConfig).value;
    });
    function show(biz) {
      tab.value.active = 'entity';
      dialogRef.open();
      load(biz);
    }
    function load(biz) {
      tab.value.loading = true;
      previewCode(biz).then(function (result) {
        preview.value = result.data;
      }).catch(function () {
        tab.value.loading = false;
        close();
      }).finally(function () {
        tab.value.loading = false;
      });
    }
    function close() {
      if (tab.value.loading) {
        return;
      }
      dialogRef.close();
    }
    function kebab(str) {
      return _kebabCase(str);
    }
    __expose({
      show: show
    });
    return function (_ctx, _cache) {
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_tabs = _resolveComponent("el-tabs");
      var _component_x_common_dialog = _resolveComponent("x-common-dialog");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_x_common_dialog, {
        ref_key: "dialogRef",
        ref: dialogRef,
        title: "代码预览",
        width: "80%"
      }, {
        default: _withCtx(function () {
          return [_withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
            modelValue: _unref(tab).active,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _unref(tab).active = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_unref(preview).entity ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: "".concat(_unref(preview).businessName, ".java"),
                name: "entity"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(entityCode)
                  }, null, 8, _hoisted_1)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).controller ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: "".concat(_unref(preview).businessName, "Controller.java"),
                name: "controller"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(controllerCode)
                  }, null, 8, _hoisted_2)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).service ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 2,
                label: "".concat(_unref(preview).businessName, "Service.java"),
                name: "service"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(serviceCode)
                  }, null, 8, _hoisted_3)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).serviceImpl ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 3,
                label: "".concat(_unref(preview).businessName, "ServiceImpl.java"),
                name: "serviceImpl"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(serviceImplCode)
                  }, null, 8, _hoisted_4)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).mapper ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 4,
                label: "".concat(_unref(preview).businessName, "Mapper.java"),
                name: "mapper"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(mapperCode)
                  }, null, 8, _hoisted_5)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).mapperXml ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 5,
                label: "".concat(_unref(preview).businessName, "Mapper.xml"),
                name: "mapperXml"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(mapperXmlCode)
                  }, null, 8, _hoisted_6)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).ieo ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 6,
                label: "".concat(_unref(preview).businessName, "IEO.java"),
                name: "ieo"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(ieoCode)
                  }, null, 8, _hoisted_7)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).importHandler ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 7,
                label: "".concat(_unref(preview).businessName, "ImportHandler.java"),
                name: "importHandler"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(importHandlerCode)
                  }, null, 8, _hoisted_8)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).api ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 8,
                label: "".concat(kebab(_unref(preview).businessName), ".ts"),
                name: "api"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(api)
                  }, null, 8, _hoisted_9)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).managerView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 9,
                label: _unref(preview).businessName + '.vue',
                name: "manager"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(managerView)
                  }, null, 8, _hoisted_10)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).viewConfig ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 10,
                label: "config.ts",
                name: "viewConfig"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(viewConfig)
                  }, null, 8, _hoisted_11)];
                }),
                _: 1
              })) : _createCommentVNode("", true), _unref(preview).createView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 11,
                label: "create.vue",
                name: "create"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(createView)
                  }, null, 8, _hoisted_12)];
                }),
                _: 1
              })) : _createCommentVNode("", true), _unref(preview).updateView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 12,
                label: "update.vue",
                name: "update"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "code-block",
                    contenteditable: "true",
                    innerHTML: _unref(updateView)
                  }, null, 8, _hoisted_13)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["modelValue"])), [[_directive_loading, _unref(tab).loading]])];
        }),
        _: 1
      }, 512);
    };
  }
});